import Service from "src/service/ApiService";
import { API_URL } from "src/constants";

const service = new Service();

export const GetTerms = () => {
  return service
    .get(API_URL.GetTerms)
    .then(res => {
      return res;
    })
    .catch(err => {
      throw err;
    });
};

export const UpdateTerms = body => {
  return service
    .post(API_URL.UpdateTerms, body)
    .then(res => {
      return res;
    })
    .catch(err => {
      throw err;
    });
};
